{
  "header": {
    "nameVariable": {
      "id": "01fa65cd-a012-44d6-9297-8d44691cf891",
      "modelUri": "http://opcfoundation.org/UA/MachineTool/",
      "nodeId": "ns=1;i=258",
      "displayName": "ProductInstanceUri",
      "variablePath": "Identification.ProductInstanceUri",
      "dataType": "String",
      "modellingRule": "Mandatory",
      "hasProperties": false
    },
    "modelVariable": {
      "id": "d2ee0b95-f686-497a-8c20-28730a8c987a",
      "modelUri": "http://opcfoundation.org/UA/Machinery/",
      "nodeId": "ns=1;i=6008",
      "displayName": "Model",
      "variablePath": "Identification.Model",
      "dataType": "LocalizedText",
      "modellingRule": "Optional",
      "hasProperties": false
    }
  },
  "imagesConfig": {
    "imageDefaults": {}
  },
  "timeline": {
    "variable": {
      "id": "b15a1091-4010-4719-87d1-6594ce4aad80",
      "modelUri": "http://opcfoundation.org/UA/Machinery/",
      "nodeId": "ns=1;i=6128",
      "displayName": "CurrentState",
      "variablePath": "MachineryBuildingBlocks.MachineryItemState.CurrentState",
      "dataType": "LocalizedText",
      "modellingRule": "Mandatory",
      "hasProperties": true,
      "hasUnit": false,
      "hasRange": false
    },
    "colorValues": {
      "NotAvailable": "#ff0000",
      "OutOfService": "#804040",
      "Executing": "#00ff00",
      "NotExecuting": "#ffff00"
    }
  },
  "sections": [
    {
      "isPlaceholder": false,
      "title": "Identification",
      "rows": [
        {
          "isPlaceholder": false,
          "elements": [
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Manufacturer",
              "valueVariable": {
                "id": "d6837b4b-bae5-4a5f-bd02-71ddd1141162",
                "modelUri": "http://opcfoundation.org/UA/DI/",
                "nodeId": "ns=1;i=6124",
                "displayName": "Manufacturer",
                "variablePath": "Identification.Manufacturer",
                "dataType": "LocalizedText",
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "ProductUri",
              "showAsLink": true,
              "valueVariable": {
                "id": "d6b618a2-0ac5-4746-9778-4d9cead71d30",
                "modelUri": "http://opcfoundation.org/UA/Machinery/",
                "nodeId": "ns=1;i=258",
                "displayName": "ProductInstanceUri",
                "variablePath": "Identification.ProductInstanceUri",
                "dataType": "String",
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Serial Number",
              "valueVariable": {
                "id": "e40be8f5-7940-410f-ad25-c90e6aa9135a",
                "modelUri": "http://opcfoundation.org/UA/DI/",
                "nodeId": "ns=1;i=6125",
                "displayName": "SerialNumber",
                "variablePath": "Identification.SerialNumber",
                "dataType": "String",
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Software Version",
              "valueVariable": {
                "id": "c8145fac-8977-4eb8-bba1-9b0a25b15201",
                "modelUri": "http://opcfoundation.org/UA/Machinery/",
                "nodeId": "ns=1;i=6011",
                "displayName": "SoftwareRevision",
                "variablePath": "Identification.SoftwareRevision",
                "dataType": "String",
                "modellingRule": "Optional",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Build Year",
              "valueVariable": {
                "id": "f8f0fefe-d3f2-49bc-ae40-eeeabba8b08a",
                "modelUri": "http://opcfoundation.org/UA/Machinery/",
                "nodeId": "ns=1;i=6004",
                "displayName": "YearOfConstruction",
                "variablePath": "Identification.YearOfConstruction",
                "dataType": "UInt16",
                "modellingRule": "Optional",
                "hasProperties": false,
                "hasUnit": false,
                "hasRange": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Device Class",
              "valueVariable": {
                "id": "ddc4aaca-9595-49c0-b3bc-e39c52f20131",
                "modelUri": "http://opcfoundation.org/UA/Machinery/",
                "nodeId": "ns=1;i=6012",
                "displayName": "DeviceClass",
                "variablePath": "Identification.DeviceClass",
                "dataType": "String",
                "modellingRule": "Optional",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Location",
              "valueVariable": {
                "id": "b5b7d4a8-097f-4c4f-8818-edb4a0a7e2de",
                "modelUri": "http://opcfoundation.org/UA/Machinery/",
                "nodeId": "ns=1;i=6029",
                "displayName": "Location",
                "variablePath": "Identification.Location",
                "dataType": "String",
                "modellingRule": "Optional",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Model",
              "valueVariable": {
                "id": "2890fa7a-5aa6-4579-b834-92597590b573",
                "modelUri": "http://opcfoundation.org/UA/Machinery/",
                "nodeId": "ns=1;i=6008",
                "displayName": "Model",
                "variablePath": "Identification.Model",
                "dataType": "LocalizedText",
                "modellingRule": "Optional",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Product Code",
              "valueVariable": {
                "id": "416889bd-eec5-4470-9867-731c9e6141a9",
                "modelUri": "http://opcfoundation.org/UA/Machinery/",
                "nodeId": "ns=1;i=6009",
                "displayName": "ProductCode",
                "variablePath": "Identification.ProductCode",
                "dataType": "String",
                "modellingRule": "Optional",
                "hasProperties": false
              }
            }
          ]
        }
      ]
    },
    {
      "isPlaceholder": false,
      "title": "DetectionSkills",
      "rows": [
        {
          "isPlaceholder": false,
          "elements": [
            {
              "type": 4,
              "isPlaceholder": false,
              "label": "",
              "valueVariable": {
                "id": "7303a66c-5987-4cbc-8541-7acd16bc6530",
                "modelUri": "http://opcfoundation.org/UA/Glass/Container/",
                "nodeId": "ns=1;i=6139",
                "displayName": "DetectionSkills",
                "variablePath": "Identification.DetectionSkills",
                "dataType": "String",
                "valueRank": 1,
                "modellingRule": "Optional",
                "hasProperties": false
              }
            }
          ]
        }
      ]
    },
    {
      "isPlaceholder": false,
      "title": "Monitoring",
      "rows": [
        {
          "isPlaceholder": false,
          "elements": [
            {
              "type": 2,
              "label": "Machinery Item State",
              "isPlaceholder": false,
              "badgeValues": [
                {
                  "backgroundColor": "#ff0000",
                  "textColor": "#000000",
                  "value": "NotAvailable",
                  "label": "Not Available"
                },
                {
                  "backgroundColor": "#804040",
                  "textColor": "#000000",
                  "value": "OutOfService",
                  "label": "Out Of Service"
                },
                {
                  "backgroundColor": "#00ff00",
                  "textColor": "#000000",
                  "value": "Executing"
                },
                {
                  "backgroundColor": "#ffff00",
                  "textColor": "#000000",
                  "value": "Not Executing"
                }
              ],
              "valueVariable": {
                "id": "897ce30a-1bbc-4051-9e76-f9809608f5cd",
                "modelUri": "http://opcfoundation.org/UA/Machinery/",
                "nodeId": "ns=1;i=6128",
                "displayName": "CurrentState",
                "variablePath": "MachineryBuildingBlocks.MachineryItemState.CurrentState",
                "dataType": "LocalizedText",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": true
              }
            },
            {
              "type": 2,
              "label": "Machinery Operation Mode",
              "isPlaceholder": false,
              "badgeValues": [
                {
                  "backgroundColor": "#0000ff",
                  "textColor": "#ffffff",
                  "value": "None"
                },
                {
                  "backgroundColor": "#fbff00",
                  "textColor": "#000000",
                  "value": "Maintenance"
                },
                {
                  "backgroundColor": "#00ff00",
                  "textColor": "#000000",
                  "value": "Production"
                },
                {
                  "backgroundColor": "#fbff00",
                  "textColor": "#000000",
                  "value": "Setup"
                }
              ],
              "valueVariable": {
                "id": "00446923-fbde-4f06-851e-3609fb052c24",
                "modelUri": "http://opcfoundation.org/UA/Machinery/",
                "nodeId": "ns=1;i=6046",
                "displayName": "CurrentState",
                "variablePath": "MachineryBuildingBlocks.MachineryOperationMode.CurrentState",
                "dataType": "LocalizedText",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": true
              }
            }
          ]
        }
      ]
    },
    {
      "isPlaceholder": false,
      "title": "RejectionStatistics",
      "rows": [
        {
          "isPlaceholder": true,
          "placeholderObject": "ProductionStatistic.<RejectedStatistics>.[PLACEHOLDER]",
          "titleVariable": {
            "id": "7c6b685c-b0cf-4bc0-a208-c2fd951685f7",
            "modelUri": "",
            "nodeId": "",
            "displayName": "BrowseName",
            "variablePath": "baseName",
            "dataType": "String",
            "modellingRule": "Mandatory",
            "hasProperties": false
          },
          "elements": [
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Count",
              "valueVariable": {
                "id": "82747215-c541-45a3-805e-bb7db0d737ce",
                "modelUri": "http://opcfoundation.org/UA/Glass/Container/",
                "nodeId": "ns=1;i=6025",
                "displayName": "Count",
                "variablePath": "Count",
                "dataType": "UInteger",
                "modellingRule": "Mandatory",
                "hasProperties": true,
                "hasUnit": true,
                "hasRange": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "RejectionReason",
              "valueVariable": {
                "id": "0bc7e7e2-94c9-4725-b47f-bd10a8d7c052",
                "modelUri": "http://opcfoundation.org/UA/Glass/Container/",
                "nodeId": "ns=1;i=6039",
                "displayName": "ValueAsText",
                "variablePath": "RejectionReason.properties.ValueAsText",
                "dataType": "LocalizedText",
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            }
          ]
        }
      ]
    }
  ]
}
